<template>
  <div class="moreBusinessInfo">
    <review-card name="moreBusinessInfoEdit" @edit="triggerModalOpening">
      <edit-more-business-info v-if="showEditModal" @close="onModalClose" />

      <template #title>{{ t('title') }}</template>

      <div class="data">
        <text-object :label="t('establishedLabel')">
          {{ establishedDate }}
        </text-object>
        <text-object :label="t('averageMonthlyRevenueLabel')">
          {{ formatMoney(business._extension.averageMonthlyRevenue) }}
        </text-object>
        <text-object :label="t('ownLabel')">
          {{ formatPercent(primaryOwner.percentOwnership) }}
        </text-object>
      </div>
    </review-card>
  </div>
</template>
<script>
import ReviewCard from '@/components/ReviewCard';
import TextObject from '@/components/TextObject';
import EditMoreBusinessInfo from '@/views/application/ReviewSubmit/EditMoreBusinessInfo';
import buildTranslators from '@/utils/build-translators';
import money from '@/filters/money';

export default {
  name: 'more-business-info',
  components: {
    ReviewCard,
    TextObject,
    EditMoreBusinessInfo,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEditModal: false,
    };
  },
  computed: {
    business() {
      return this.application.business;
    },
    primaryOwner() {
      return this.application.owners[0];
    },
    establishedDate() {
      const month = this.business._extension.establishedMonth
        ? `${this.$t(`months.${this.business._extension.establishedMonth}`)} `
        : '';

      return `${month}${this.business.establishedDate.slice(0, 4)}`;
    },
  },
  methods: {
    formatMoney: money,
    triggerModalOpening() {
      this.showEditModal = true;
      document.documentElement.style.overflow = 'hidden';
    },
    formatPercent(value) {
      return value && `${value}%`;
    },
    onModalClose() {
      this.showEditModal = false;
      this.$emit('modalClose');
      document.documentElement.style.overflow = 'auto';
    },
    t(key, options) {
      return buildTranslators('reviewSubmit.card.moreBusinessInfo').t(key, options);
    },
  },
};
</script>
<style lang="sass" scoped>
.data
  display: grid
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr)
  row-gap: $glass-spacing-4
  column-gap: $glass-spacing-3

  +mq($stego)
    grid-template-columns: repeat(3, minmax(0, 1fr))

.address
  white-space: pre-line
</style>
